import styled, { ITheme } from '../../../theme'

const Label = styled.div<{ size?: number }>`
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  white-space: nowrap;
  color: ${(props: ITheme) => props.theme.colors.palette.slateGrey};
`

export default Label
